import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Récupère les paramètres d'URL
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const error = params.get("error");
    const firstName = params.get("firstName");
    const lastName = params.get("lastName");
    const profilePicture = params.get("profilePicture");

    if (token) {
      // Stocke le token dans localStorage
      localStorage.setItem("token", token);

      // Décode le token pour obtenir les informations utilisateur
      try {
        const payload = JSON.parse(
          atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))
        );

        // Stocke le statut d'administrateur
        localStorage.setItem("isAdmin", payload.isAdmin);

        // Stocke les informations additionnelles si présentes
        if (firstName && lastName) {
          localStorage.setItem("userName", `${firstName} ${lastName}`);
        }

        if (profilePicture) {
          localStorage.setItem("profilePicture", profilePicture);
        }

        // Notification
        toast.success("Connexion réussie avec Google !");

        // Redirection basée sur le rôle
        if (payload.isAdmin) {
          navigate("/admin");
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Erreur lors du traitement du token:", error);
        toast.error("Erreur lors de la connexion. Veuillez réessayer.");
        navigate("/login");
      }
    } else if (error) {
      // Gestion des erreurs
      toast.error("Échec de l'authentification Google. Veuillez réessayer.");
      navigate("/login");
    } else {
      // Si aucun token ni erreur, redirection vers la page de connexion
      navigate("/login");
    }
  }, [location, navigate]);

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100">
      <div className="text-center">
        <div
          className="spinner-border text-primary mb-4"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Chargement...</span>
        </div>
        <h3>Finalisation de la connexion...</h3>
        <p className="text-muted">Veuillez patienter quelques instants...</p>
      </div>
    </div>
  );
}

export default AuthCallback;
